import React from "react"
import { Col, Label } from "reactstrap"
import Select from "react-select"
import { customStylesSelect } from "common/data/settings"

const CustomSelectwithLabel = ({
  defaultValue,
  label,
  id,
  onChange,
  value,
  placeholder,
  isMulti,
  options,
  isClearable,
}) => {
  return (
    <>
      <Col md="3">
        <div>
          <Label htmlFor="formrow-state-Input">{label}</Label>
          <Select
            isClearable={isClearable ? isClearable : false}
            className="mb-2"
            isMulti={isMulti ? isMulti : false}
            value={value}
            defaultValue={defaultValue}
            placeholder={placeholder}
            onChange={value => onChange(value)}
            options={options}
            classNamePrefix="select2-selection"
            styles={customStylesSelect}
            id={id}
          />
        </div>
      </Col>
    </>
  )
}

export default CustomSelectwithLabel
